define('collections/lead_notes',['require','collections/base','models/lead_note'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/lead_note");

    return BaseCollection.extend({
        model: Model,
        url: 'lead-notes.json'
    });
});

